/**
 * ImageSize defines the viewport width and optimal image pixel width
 * for a responsive image in a particular viewport.
 */
export interface ImageSrcSetSize {
  viewport: number;
  image: number;
}

/**
 * Default image sizes for Image components.  These sizes are used to
 * generate the srcset attribute for responsive images.  This srcset
 * assumes that the images are full viewport width at all viewport sizes.
 */
export const IMAGE_SIZES_DEFAULT: ImageSrcSetSize[] = [
  { viewport: 420, image: 420 },
  { viewport: 640, image: 640 },
  { viewport: 800, image: 800 },
  { viewport: 1024, image: 1024 },
  { viewport: 1280, image: 1280 },
  { viewport: 1600, image: 1600 },
  { viewport: 2000, image: 2000 },
];

/**
 * Bento grid image sizes for full-width items (spans 2 columns on desktop).
 * Mobile: full viewport width. Desktop: ~1024px max (max-w-screen-lg container).
 * Includes DPR variants (1x, 2x, 3x) for retina displays.
 */
export const IMAGE_SIZES_BENTO_FULL: ImageSrcSetSize[] = [
  { viewport: 420, image: 420 },
  { viewport: 640, image: 640 },
  { viewport: 768, image: 800 },
  { viewport: 1023, image: 1024 },
];

/**
 * Bento grid image sizes for half-width items (1 column on desktop).
 * Mobile: full viewport width. Desktop: ~500px (half of max-w-screen-lg).
 * Includes DPR variants (1x, 2x, 3x) for retina displays.
 */
export const IMAGE_SIZES_BENTO_HALF: ImageSrcSetSize[] = [
  { viewport: 420, image: 420 },
  { viewport: 640, image: 640 },
  { viewport: 768, image: 800 },
  { viewport: 1024, image: 520 },
];
